import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@app/guards/auth.guard';

import { ProfileDocumentsComponent } from './components';
import { ProfileComponent } from './profile.component';

const routes: Routes = [
  { path: 'profile', redirectTo: 'profile/settings', pathMatch: 'full' },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    children: [
      { path: 'settings', component: ProfileComponent },
      { path: 'documents', component: ProfileDocumentsComponent }
    ]
  },
  { path: 'settings', redirectTo: 'profile/settings', pathMatch: 'full' },
  { path: 'documents', redirectTo: 'profile/documents', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule {}
